import angular from 'angular'

import { DashboardContainerComponent } from './dashboard-container.component'
import { DashboardContentComponent } from './dashboard-content.component';
import { DashboardSummaryTableComponent } from './dashboard-summary-table/dashboard-summary-table.component';
import { DashboardSummaryService } from './dashboard-summary-table/dashboard-summary.service';

export const DashboardModule = angular
    .module("apex.mainApp.dashboard", [])
    .component("apexDashboard", DashboardContainerComponent)
    .component("apexDashboardContent", DashboardContentComponent)
    .component("apexDashboardSummaryTable", DashboardSummaryTableComponent)
    .service("dashboardSummaryService", DashboardSummaryService)
    .name
